import { createRoutine } from "redux-saga-routines";

export const loadAll = createRoutine("LAB_CONTROL/LOAD_ALL");
export const loadOne = createRoutine("LAB_CONTROL/LOAD_ONE");
export const create = createRoutine("LAB_CONTROL/CREATE");
export const controlGivenIds = createRoutine("LAB_CONTROL/CONTROL_WITH_IDS");
export const deleteOne = createRoutine("LAB_CONTROL/DELETE");
export const update = createRoutine("LAB_CONTROL/UPDATE");
export const acceptGivenIds=createRoutine("LAB_CONTROL/ACCEPT_GIVEN_IDS");
export const checkGivenIds=createRoutine("LAB_CONTROL/CHECK_GIVEN_IDS");  